import { ButtonGroup, Button } from "@datapay-by-datacom/design-system";
import { OrgInvitation } from "../../../generated/core-api";
import { useRescindOrgInvitation } from "../../hooks";

interface OrgInviteTableActionsProps {
  invite: OrgInvitation;
}

export function OrgInviteTableActions({ invite }: OrgInviteTableActionsProps) {
  const rescindMutation = useRescindOrgInvitation();

  const handleRescind = () => {
    rescindMutation.mutate({
      category: invite.org_category,
      orgId: invite.org_id,
      invitationId: invite.invitation_id,
    });
  };

  return (
    <ButtonGroup>
      <Button
        variant="secondary"
        size="small"
        onPress={handleRescind}
        isDisabled={rescindMutation.isPending}
      >
        {rescindMutation.isPending ? "Rescinding..." : "Rescind"}
      </Button>
    </ButtonGroup>
  );
}
